export default "__VITE_ASSET__Q7_hEXxm__"